import { useMutation } from "@apollo/client/react";
import { CREATE_INVOICE_UPLOAD_UNIT } from "../../mutations/documentHandler/createInvoiceUploadUnit";
import GET_ALL_UPLOAD_UNITS from "../../queries/documentHandler/getAllUploadUnits";
import GET_CLIENTS_WITH_UPLOAD_UNITS from "../../queries/documentHandler/getClientsWithUploadUnits";

export const useCreateInvoiceUploadUnit = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result: any) => void;
  onError: (error: any) => void;
}) => {
  const [createInvoiceUploadUnit, { data, loading, error }] = useMutation(
    CREATE_INVOICE_UPLOAD_UNIT,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: [GET_ALL_UPLOAD_UNITS, GET_CLIENTS_WITH_UPLOAD_UNITS],
      awaitRefetchQueries: true,
    },
  );

  return { createInvoiceUploadUnit, data, loading, error };
};
